import { createEffect, createEvent } from 'effector';

import { IamUser } from '@m/types/api/iam/Iam';
import { UserAdminService } from 'apps/admin/services';

export const assignUserToEmployer = createEffect(UserAdminService.setUserEmployer);
export const setSelectedUser = createEvent<IamUser | undefined | null>();
